import styled from "styled-components";

import { Image } from "shared/components/atoms/Image";
import DateSelect from "features/media/components/molecules/DateSelect";
import Radio from "features/media/components/atoms/Radio";
import { Topic } from "shared/types";
import { useState } from "react";
import { TopicElement } from "shared/types";
import { CTVRButton } from "../atoms/CTVRButton";

interface Props {
  data: TopicElement;
  topic: Topic;
  withStories?: boolean;
}

export default function Fortune({ data, topic, withStories = false }: Props) {
  const [checked, setChecked] = useState("");
  const rowFormatType = data.formatType === "fortune_with_stories" ? 41 : 40;

  const onClick = (value: string) => {
    setChecked(value);
  };

  return (
    <Wrapper>
      <Container>
        <Image
          src="https://cdn.miror.jp/item/free_fortune_component_header_image_02.png"
          width={578}
          height={98}
          layout="responsive"
        />
        <H5>
          無料！的中本格占い
          <PoweredBy>powerd by MIROR</PoweredBy>
        </H5>
      </Container>
      <Container>
        <H6>この鑑定では下記の内容を占います</H6>
        <Contents>{data.text}</Contents>
      </Container>
      {withStories && (
        <Container>
          <H6>
            当たってる！
            <br />
            感謝の声が沢山届いています
          </H6>
          <Image
            src="https://cdn.miror.jp/item/customer_voices.png"
            width={678}
            height={1004}
            layout="responsive"
          />
        </Container>
      )}
      <Container>
        <H6>あなたの生年月日を教えてください</H6>
        <DateSelect />
      </Container>
      <Container>
        <H6>あなたの性別を教えてください</H6>
        <div tw="flex items-center justify-between">
          <Radio value="male" checked={checked} onClick={onClick}>
            男性
          </Radio>
          <Radio value="female" checked={checked} onClick={onClick}>
            女性
          </Radio>
          <Radio value="other" checked={checked} onClick={onClick}>
            その他
          </Radio>
        </div>
      </Container>
      <Container>
        {["https://lin.ee/q4l1HZe", "https://lin.ee/tGQC9hp"].includes(
          data.siteUrl
        ) ? (
          <CTVRButton href={data.siteUrl} />
        ) : (
          <a
            href={data.siteUrl}
            tw="bg-white w-full h-16 rounded-full flex-center relative font-base text-lg text-[#070707] tracking-[3.11px] reflective after:reflection"
            css={{ boxShadow: "0px 8px 8px -2px rgba(0, 0, 0, 0.4)" }}
            id={`free_fortune_${topic.id}_format_${rowFormatType}_button`}
          >
            {`無料の占い結果を見る >`}
            <Image
              tw="w-[58px] absolute -top-0.5 -left-1"
              src="https://cdn.miror.jp/item/free_label.png"
              width={120}
              height={132}
              layout="responsive"
            />
          </a>
        )}
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: url("https://cdn.miror.jp/lp/61/item_17.png");
  background-size: cover;
  border-radius: 8px;
`;

const Container = styled.div`
  padding: 24px;
  border-bottom: 1px solid #fff;
`;

const H5 = styled.h5`
  font-weight: 800;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 32px;
  color: #fff;
  font-family: Hiragino Sans;
  text-align: center;
  text-shadow: 0 0 4px #d8039f;
`;

const PoweredBy = styled.span`
  font-size: 12px;
  display: block;
`;

const H6 = styled.h6`
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  margin-bottom: 16px;
`;

const Contents = styled.span`
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 24px;
  color: #fff;
  text-align: left;
  white-space: pre-wrap;
`;
